import React from 'react'

import { Form, Col } from '_zari/core'

import { RounderUtil } from 'utils'

const MargenUtilidadPromedioFormGroup = ({ vPrecioNeto, infoCostosProducto }) => {
  const [utilidadCalculada, setUtilidadCalculada] = React.useState(0)

  React.useEffect(() => {
    if (vPrecioNeto && infoCostosProducto.costoPromedio) {
      const diferencia = RounderUtil.round(vPrecioNeto - infoCostosProducto.costoPromedio, 4)
      const utilidad = RounderUtil.round((diferencia / infoCostosProducto.costoPromedio) * 100, 2)
      setUtilidadCalculada(utilidad)
    } else {
      setUtilidadCalculada(0)
    }
  }, [vPrecioNeto, infoCostosProducto])

  return (
    <Form.Group>
      <Form.Label text='% UTIL PROM' htmlFor='input-margenUtilidadPromedio' xs={12} />
      <Col xs={12}>
        <Form.InputText
          disabled
          id='input-margenUtilidadPromedio'
          name='input-margenUtilidadPromedio'
          value={utilidadCalculada}
          onChange={() => ({})}
          isInvalid={utilidadCalculada < 0}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(MargenUtilidadPromedioFormGroup)
